import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { APP_ROUTERS } from "@/constants/app-routers";
import {
  presaleCampaignSearchSchema,
  presaleUtmSearchFragment,
} from "@/features/presale";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  ...presaleCampaignSearchSchema.shape,
  // An ENTRY point: `/presale`'s `beforeLoad` forwards only what its schema validated, so
  // an unlisted `utm_*` would die on the hop to step 1 before any component renders.
  ...presaleUtmSearchFragment,
  ...maskSearchFragment,
});

/**
 * `/presale` is the funnel's entry, not a page — it hands off to step 1 the way
 * `/join` does. `validateSearch` is what keeps a campaign link's params typed
 * across the hop; `/presale/sign-up` validates this same shape. The confirmation
 * that used to live here is now `/presale/success`.
 */
export const Route = createFileRoute("/(member)/(public)/presale/")({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: APP_ROUTERS.PRESALE_SIGN_UP,
      search,
      // Without `replace`, Back from step 1 returns here and redirects forward again.
      replace: true,
    });
  },
});
